module.exports = __webpack_public_path__ + "img/pr-20.abb86633.png";